var map = {
	"./symbol_0.png": "963e",
	"./symbol_1.png": "fc82",
	"./symbol_10.png": "1da0",
	"./symbol_2.png": "4ff3",
	"./symbol_3.png": "be27",
	"./symbol_4.png": "c2d2",
	"./symbol_5.png": "d4c0",
	"./symbol_6.png": "02cf",
	"./symbol_7.png": "654e",
	"./symbol_8.png": "4fea",
	"./symbol_9.png": "7317"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f704";